import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GameInfoService {
  http = inject(HttpClient);
  backend = inject(BackendService);
  gameInfo: any;

  constructor() { }

  getGameInfo(uuid:string){
    return this.http.get(`${this.backend.getApiUrl()}/rooms/${uuid}`);
  }

  startGame(uuid:string, startingLevel: number){
    //this.http.post(`${this.backend.getApiUrl()}/rooms/${uuid}/game-start`,{}).subscribe();
    return this.http.post(`${this.backend.getApiUrl()}/rooms/${uuid}/game-start`,{starting_level: startingLevel});
    // return this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}`,{stage_slug: "inprogress"});
    //return this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}`,{stage_slug: "inprogress"}).subscribe(); 
  }

  finishGame(uuid:string){
    this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}`,{stage_slug: "finished"}).subscribe();
  }

  closedGame(uuid:string){
    this.http.put(`${this.backend.getApiUrl()}/rooms/${uuid}`,{stage_slug: "closed"}).subscribe();
  }

  deleteGame(uuid:string){
    this.http.delete(`${this.backend.getApiUrl()}/rooms/${uuid}`).subscribe()
  }

  nextTurnGame(uuid:string): Observable<any>{
    return this.http.post(`${this.backend.getApiUrl()}/rooms/${uuid}/next-turn`,{options: {}});
  }

  nextTurnPlayer(uuid:string): Observable<any>{
    return this.nextTurnGame(uuid);
  }

  lastTurn(uuid: string): Observable<any>{
    return this.http.post(`${this.backend.getApiUrl()}/rooms/${uuid}/last-turn`, {options: {}});
  }

}
